import { Outlet } from 'react-router-dom';

export default function Charts() {
    return (
        <Outlet />
    )
}
